<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-4" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Ihr zuletzt gemessener Nüchternblutzuckerwert</span>
            <p class="new-text-lg text-centered">Bitte geben Sie Ihren Nüchternblutzuckerwert in der von Ihnen genutzten Einheit an.</p>
        </header>

        <div class="form-input-wrapper">
            <form-input-type-select
                name="unit"
                label="Einheit"
                :options="[
                    {label: 'Mg/dl', value: 'mgdl'},
                    {label: 'Mmol/l', value: 'mmoll'},
                ]"
                :value="unit"
                full-border
                required
            />

            <form-input-type-text
                name="value"
                label="Wert"
                :errors="errors.value"
                :value="value"
                full-border
                required
            />

            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },
        
        data() {
            return {
                isDisabled: true,
                errors: {},
                unit: (this.data && this.data.glucose_unit) ?? 'mgdl',
                value: (this.data && this.data.glucose_value)
            }
        },

        mounted() {
            var that = this
            
            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50); 
        },

        methods: {
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                if($("#value").val() == "") {
                    this.errors.value = ["Wert muss angegeben werden."]
                    this.isDisabled = true
                    this.$forceUpdate();
                }

                if($("#value").val() !== "") {
                    this.errors = {
                        value: null
                    }
                    this.isDisabled = false
                    this.$forceUpdate();
                }
            },
            submit() {
                var unit = document.getElementById('unit').value
                var value = document.getElementById('value').value

                var data = {
                    uuid: this.uuid,
                    answers: {
                        glucose_unit: {
                            key: 'glucose_unit',
                            value: unit
                        },
                        glucose_value: {
                            key: 'glucose_value',
                            value: value
                        },
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '5' : '3'
                        }
                    }
                }

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            saveData() {
                var unit = document.getElementById('unit').value
                var value = document.getElementById('value').value

                var data = {
                    answers: {
                        glucose_unit: {
                            key: 'glucose_unit',
                            value: unit
                        },
                        glucose_value: {
                            key: 'glucose_value',
                            value: value
                        },
                    }
                }

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>